import {
  ClassesIllustration,
  DivisionIllustration,
  GradegroupsIllustration,
  ImportIcon,
  RoomIllustration,
  SchoolYearIllustration,
  SubjectIllustration,
  TeacherIllustration,
  UsersetupIllustration,
} from '@bp/ui-components';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { IconMenu } from '../../components/IconMenu/IconMenu';
import { IconMenuItem } from '../../components/IconMenuItem/IconMenuItem';
import { Page } from '../../components/Page/Page';
import { usePermissionChecker } from '../../hooks/usePermissionChecker';

export const SettingsPage: FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const permissions = usePermissionChecker();

  return (
    <Page isForbidden={!permissions?.canManageSettings()} title={t('settings.title', { count: 2 })}>
      <IconMenu headline={t('common.coreData')}>
        <IconMenuItem
          label={`${t('subject.title', { count: 2 })}/${t('subjectContainer.title', { count: 2 })}`}
          icon={<SubjectIllustration />}
          bubbleType={1}
          onClick={() => navigate(t('routes.subjects.slug'))}
        />
        <IconMenuItem
          label={t('persons.title', { count: 2 })}
          icon={<TeacherIllustration />}
          bubbleType={2}
          onClick={() => navigate(t('routes.teacher.slug'))}
        />
        <IconMenuItem
          label={t('classes.title', { count: 2 })}
          icon={<ClassesIllustration />}
          bubbleType={3}
          onClick={() => navigate(t('routes.classes.slug'))}
        />
        <IconMenuItem
          label={t('rooms.titleLong')}
          icon={<RoomIllustration />}
          bubbleType={4}
          onClick={() => navigate(t('routes.rooms.slug'))}
        />
      </IconMenu>
      <IconMenu hasMarginTop headline={t('common.additionalData')}>
        <IconMenuItem
          label={`${t('schoolYear.title', { count: 2 })}/${t('holidays.title', {
            count: 2,
          })}`}
          icon={<SchoolYearIllustration />}
          bubbleType={14}
          onClick={() => navigate(t('routes.schoolyear.slug'))}
        />
        <IconMenuItem
          label={t('routes.divisions.title')}
          icon={<DivisionIllustration />}
          bubbleType={16}
          onClick={() => navigate(t('routes.divisions.slug'))}
        />
        <IconMenuItem
          label={t('routes.gradeGroups.title')}
          icon={<GradegroupsIllustration />}
          bubbleType={15}
          onClick={() => navigate(t('routes.gradeGroups.slug'))}
        />
        <IconMenuItem
          label={t('routes.users.title')}
          icon={<UsersetupIllustration />}
          bubbleType={12}
          onClick={() => navigate(t('routes.users.slug'))}
        />
      </IconMenu>
    </Page>
  );
};
